import { render, staticRenderFns } from "./GovermentRegistrationDlg.vue?vue&type=template&id=65f19665&"
import script from "./GovermentRegistrationDlg.vue?vue&type=script&lang=js&"
export * from "./GovermentRegistrationDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports